import { formatDurationToTime } from "@stepapp/core";
import { CategoryType } from "@stepapp/core/apiTypes";
import { Block, LinePlaceholder, SvgIcon, Typography, palette, useBreakpoints } from "@stepapp/ui";
import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
  timeConsumption?: string;
  marginVertical?: number;
  showDescription?: boolean;
  showClockIcon?: boolean;
  loading?: boolean;
  categoryType?: CategoryType | null;
};

const AverageCleaningTime = ({
  timeConsumption,
  marginVertical = 0,
  showDescription = false,
  showClockIcon = false,
  loading = false,
  categoryType = CategoryType?.Cleaning,
}: Props) => {
  const { t } = useTranslation();
  const { mobileOnly } = useBreakpoints();

  const serviceTime = formatDurationToTime(timeConsumption || "P0D");

  const canShowDescription = showDescription && categoryType !== CategoryType?.Massage;

  return (
    <Block marginVertical={marginVertical}>
      <Block row justifySpace flex={1} marginBottom={1.5} alignCenter>
        <Block row flex={1} alignCenter>
          {showClockIcon && (
            <SvgIcon color={palette.font.secondary} name="clock-outline" size={22} />
          )}
          <Block flex={1} marginLeft={showClockIcon ? 1 : 0}>
            <Typography variant={showClockIcon ? "paragraph" : "bodyBold"}>
              {t("screens.service.averageCleaningTime", { context: categoryType?.toLowerCase() })}
            </Typography>
          </Block>
        </Block>

        {loading ? (
          <LinePlaceholder height={3} width={10} />
        ) : (
          <Typography variant="newH3">{serviceTime}</Typography>
        )}
      </Block>

      {canShowDescription && (
        <Typography type="secondary" variant={mobileOnly ? "lightLabel" : "paragraph"}>
          {t("screens.service.averageCleaningTimeDescription")}
        </Typography>
      )}
    </Block>
  );
};

export default React.memo(AverageCleaningTime);
